import { createSelector } from 'reselect';
import { getTravelKe } from './index';
import { FORM_STATUS, API_CALL_STATUS } from '../../reducers/status';
export const getQuote = createSelector(getTravelKe, (state) => {
    return state && state.quote;
});

export const getQuoteForm = createSelector(getQuote, (quote) => quote && quote.form);
export const getQuoteFormValid = createSelector(getQuote, (quote) => quote && quote.formStatus === FORM_STATUS.VALID);
export const getPremiumCalculation = createSelector(getQuote, (quote) => quote && quote.premiumCalculation);

export const getQuoteFormApiCallStatus = createSelector(getQuote, (quote) => quote && quote.apiCallStatus);
export const getQuoteFormApiCallSuccess = createSelector(
    getQuote,
    (quote) => quote && quote.apiCallStatus === API_CALL_STATUS.SUCCESS
);
export const getQuoteFormApiCallFailure = createSelector(
    getQuote,
    (quote) => quote && quote.apiCallStatus === API_CALL_STATUS.FAILURE
);
export const getIsApiPending = createSelector(
    getQuote,
    (quote) => quote && quote.apiCallStatus === API_CALL_STATUS.PENDING
);
export const getAddedCover = createSelector(getQuote, (quote) => quote && quote.addedCover);
export const getShareModalValue = createSelector(getQuote, (quote) => quote && quote.showShareModal);
export const getShareQuoteAPIStatus = createSelector(getQuote, (quote) => quote && quote.shareQuoteAPIStatus);
export const getShareQuoteFormStatus = createSelector(getQuote, (quote) => quote && quote.shareQuoteFormStatus);
export const getUgCmbObject = createSelector(getQuote, (quote) => quote && quote.ugCmbObject);
export const getIsApiPendingCountries = createSelector(getQuote, (quote) => quote && quote.apiPendingCountries);
export const getCountries = createSelector(getQuote, (quote) => quote && quote.countries);
export const getIsApiPendingBenefits = createSelector(getQuote, (quote) => quote && quote.getIsApiPendingBenefits);
export const getBenefitsEurope = createSelector(getQuote, (quote) => quote && quote.benefitsEurope);
export const getBenefitsAfrica = createSelector(getQuote, (quote) => quote && quote.benefitsAfrica);
export const getBenefitsAsia = createSelector(getQuote, (quote) => quote && quote.benefitsAsia);
export const getBenefitsWorldwide = createSelector(getQuote, (quote) => quote && quote.benefitsWorldwide);
export const getBenefitsStudents = createSelector(getQuote, (quote) => quote && quote.benefitsStudents);
export const getBenefitsPilgrimage = createSelector(getQuote, (quote) => quote && quote.benefitsPilgrimage);

export const getPlanValue = createSelector(getQuote, (quote) => quote && quote.plan);
export const getSegmentValue = createSelector(getQuote, (quote) => quote && quote.segment);
export const getSectionValue = createSelector(getQuote, (quote) => quote && quote.section);

const makeGetFormField = (fieldId) => createSelector(getQuoteForm, (form) => form[fieldId]);
export const getCurrentlyInKenyaValue = makeGetFormField('currentlyInKenya');
export const getPhoneNumber = makeGetFormField('phoneNumber');
export const getName = makeGetFormField('name');
export const getEmail = makeGetFormField('email');
export const getTripType = makeGetFormField('tripType');
export const getCoverFor = makeGetFormField('coverFor');
export const getDepartureCountry = makeGetFormField('departureCountry');
export const getDestinationCountry = makeGetFormField('destinationCountry');
export const getDepatureDate = makeGetFormField('departureDate');
export const getReturnDate = makeGetFormField('returnDate');
export const getNoOfTravellers = makeGetFormField('noOfTravellers');
export const getNoOfMinors = makeGetFormField('noOfMinors');
export const getNoOfAdults = makeGetFormField('noOfAdults');
export const getNoOfSeniors = makeGetFormField('noOfSeniors');
export const getNoOfSeniors76 = makeGetFormField('noOfSeniors76');
export const getNoOfSeniors81 = makeGetFormField('noOfSeniors81');
export const getSelectedCover = makeGetFormField('selectedCover');
export const getShareEmailValue = makeGetFormField('shareEmail');
export const getDob = makeGetFormField('dob');
